<div class="p-grid">
	<div class="p-col-12 p-md-3">
		<div class="d-flex">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideDelete]="true"
				[hideSave]="true"
				(onAddChange)="add()"
				[addDisabled]="isAdding"
			></app-record-control-footer>
		</div>
		<p-table
			#dt
			styleClass="p-datatable-responsive-demo"
			[value]="tableModelList"
			[loading]="!tableModelList"
			[globalFilterFields]="app.keys(tableModelList)"
			[rowHover]="true"
			[rows]="10"
			[showCurrentPageReport]="true"
			[rowsPerPageOptions]="[10, 25, 50]"
			responsiveLayout="scroll"
			[paginator]="true"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} recordName"
		>
			<ng-template pTemplate="caption">
				<div class="table-header d-flex">
					<div class="flex-grow-1">
						<span class="p-float-label p-input-icon-left m-2 w-100">
							<i class="pi pi-search"></i>
							<input
								pInputText
								class="w-100"
								id="globalSearch"
								name="globalSearch"
								style="width: 100%"
								type="text"
								(input)="dt.filterGlobal($event.target.value, 'contains')"
							/>
							<label for="globalSearch">Search...</label>
						</span>
					</div>
				</div>
			</ng-template>
			<ng-template pTemplate="header">
				<tr>
					<th>Model</th>
				</tr>
			</ng-template>
			<ng-template let-rec pTemplate="body">
				<tr (click)="tableModelSelected = rec">
					{{
						rec.name
					}}
				</tr>
			</ng-template>
		</p-table>
	</div>
	<div class="p-col-12 p-md-9">
		<div class="card">
			<app-table-data-model-setup [tableModel]="tableModelSelected" (tableModelChange)="tableModelSaved($event)"></app-table-data-model-setup>
		</div>
	</div>
</div>
